<template>
    <div class="exchange">
        <div class="code">
            <img src="@/assets/home/down.jpg" />
        </div>

        <div class="text">
            <p>最新匯率<span class="C2">僅供參考</span></p>
            <p class="D8">***實際價格以店鋪為準***</p>
        </div>
        <p class="time">{{ formattedTime }}</p>

        <!-- 汇率表 -->
        <div class="rate">
            <el-table :data="tableData" border stripe style="width: 100%">
                <el-table-column label="currency/貨幣">
                    <template slot-scope="scope">
                        <el-image
                            :src="'https:/api.xiaonvh.com' + scope.row.iconUrl"
                            style="width: 30px; height: 30px"
                        ></el-image>
                        <span style="margin-left: 10px">
                            {{
                                scope.row.symbol +
                                '&nbsp;' +
                                scope.row.nameCnHant
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="We Buy Notes/现钞買入">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.buyRate }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="We Sell Notes/现钞買出">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.sellRate }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <bottom></bottom>
    </div>
</template>

<script>
import bottom from '@/components/bottom.vue'
import axios from 'axios'
export default {
    data() {
        return {
            currentTime: new Date(),

            tableData: []
        }
    },
    components: {
        bottom
    },
    computed: {
        formattedTime() {
            const year = this.currentTime.getFullYear()
            const month = String(this.currentTime.getMonth() + 1).padStart(
                2,
                '0'
            )
            const day = String(this.currentTime.getDate()).padStart(2, '0')
            const hour = String(this.currentTime.getHours()).padStart(2, '0')
            const minute = String(this.currentTime.getMinutes()).padStart(
                2,
                '0'
            )
            return `${year}年${month}月${day}日 ${hour}:${minute}`
        }
    },
    created() {
        const that = this
        axios({
            method: 'post',
            url: 'https://api.xiaonvh.com/app/currency/getAllRecentlyDept?pageNum=2&pageSize=50',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            if (response.data.code === 200) {
                that.tableData = [...response.data.list]
                console.log(response.data.list)
            }
        })
    },
    mounted() {
        setInterval(() => {
            this.currentTime = new Date()
        }, 10000) // 更新时间间隔为10秒
    }
}
</script>

<style lang="less" scoped>
::v-deep .el-table__body td {
    padding: 0;
}
.exchange {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .code {
        width: 1036px; //86vw;
        img {
            width: 100%;
        }
    }
    .text {
        text-align: center;
        font-size: 20px;
        line-height: 14px;
        font-weight: 550;
        margin-top: 3vh;
        .C2 {
            color: #c23b3b;
        }
        .D8 {
            color: #8d2424;
        }
    }
    .time {
        font-size: 20px;
        color: #3f3f3f;
        font-weight: 550;
    }
    .rate {
        width: 600px; //94vw
        height: auto;
        margin-bottom: 6vh;
    }
}
@media screen and (max-width: 584px) {
    .rate {
        width: 94vw !important;
    }
}

@media screen and (max-width: 1042px) {
    .code {
        width: 86vw !important;
    }
}
</style>